import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Area } from '../../core/constants/area';
import { WorkflowDetailListResponse } from './models/responses';
import { IftaReadyToFileAuditResponses } from '../../fleet-manager/mileage-fuel/models/responses';

@Injectable()
export class WorkflowDetailService {

  constructor(public httpClient: HttpClient) { }

  getWorkflowDetailList(workflowId: number, workflowStepId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/List?workflowId=${workflowId}&workflowStepId=${workflowStepId}`;
    return this.httpClient.get<any[]>(url);
  }
  //
  getWorkflowDetailListNonIfta(workflowStepId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/ListNonIfta?workflowStepId=${workflowStepId}`;
    return this.httpClient.get<any[]>(url);
  }
  getCompletedWorkflowDetailListNonIfta(companyId: number, createdDateStart: string, createdDateEnd: string){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/ListCompletedNonIfta?companyId=${companyId}&createdStartDate=${createdDateStart}&createdEndDate=${createdDateEnd}`;
    return this.httpClient.get<WorkflowDetailListResponse[]>(url);
  }
  getWorkflowHistoryList(companyId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/History/List?companyId=${companyId}`;
    return this.httpClient.get<any[]>(url);
  }
  getWorkflowDetailNoteList(workflowDetailId: number){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/Note/List/${workflowDetailId}`;
    return this.httpClient.get<any[]>(url);
  }
  checkIftaFilingButton(companyId: number, period: string){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/CheckIftaFilingButton?companyId=${companyId}&period=${period}`;
    return this.httpClient.get<any[]>(url);
  }
  checkIftaReadyToFileStatus(companyId: number, period: string){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/IftaReadyToFileStatus?companyId=${companyId}&period=${period}`;
    return this.httpClient.get<IftaReadyToFileAuditResponses>(url);
  }
  processIftaReadyToFile(companyId: number, period: string){
    const payload = {
      companyId: companyId,
      period: period
    }
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/ProcessIftaReadyToFile`;
    return this.httpClient.post<any[]>(url, payload)
  }
  processIftaChecklistReadyToFile(companyId: number, period: string){
    const payload = {
      companyId: companyId,
      period: period
    }
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/ProcessIftaChecklistReadyToFile`;
    return this.httpClient.post<any[]>(url, payload)
  }

  archiveWorkflowDetailByInvoice(invoiceId: number, workflowDetailId: number, isActive: boolean) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/changeIsActive`;
		return this.httpClient.post<any[]>(url, { InvoiceId: invoiceId, WorkflowDetailId: workflowDetailId, IsActive: isActive });
	}

	unwindInvoice(invoiceId: number) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/Invoice/Unwind`;
		return this.httpClient.post<void>(url, { invoiceId });
	}

	completeWorkflow(workflowDetailId: number) {
		const url = `${environment.dotNetApiUrl}/${Area.transportation}/WorkflowDetail/Complete/${workflowDetailId}`;
		return this.httpClient.post<number>(url, {});
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/workflow/workflow-detail.service.ts